import * as angular from "angular";
import marked from "marked";
import template from "./markdown.html";

export function renderMarkdown(content: string, sanitize: (html: string) => string): string {
	const renderer = new marked.Renderer();
	const link = renderer.link.bind(renderer);

	renderer.link = (href, title, text) => {
		if(typeof href !== "string") {
			return text;
		}

		const hasUnsafeCharacter = Array.from(href).some(
			character => character.charCodeAt(0) <= 32 || character.charCodeAt(0) === 127 || character === "\\"
		);
		const hasAllowedProtocol = /^(https?:\/\/[^/?#]+(?:[/?#].*)?|mailto:[^/?#]+(?:\?.*)?|tel:\+?[\d().-]+)$/i.test(href);

		return !hasUnsafeCharacter && hasAllowedProtocol
			? link(href, title, text).replace("<a ", '<a target="_blank" rel="noopener noreferrer" ')
			: text;
	};
	renderer.html = () => "";
	renderer.image = () => "";

	return sanitize(marked(content, { renderer }));
}

interface MarkdownController {
	content?: string;
}

// AngularJS owns the merged binding properties.
// eslint-disable-next-line no-redeclare
class MarkdownController implements angular.IController {
	public static $inject = ["$sanitize"];

	public html = "";

	public constructor(private sanitize: (html: string) => string) {}

	public $onChanges(): void {
		this.html = typeof this.content === "string" ? renderMarkdown(this.content, this.sanitize) : "";
	}
}

export default angular.module("vesl.extensions.json-schema.markdown-content", ["ngSanitize"])
	.component("jsonSchemaMarkdown", {
		template,
		controller: MarkdownController,
		bindings: { content: "<" }
	})
	.name;
